import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IRavioliMediaProps } from "./RavioliMedia.props";

const ratios = {
  "1:1": "aspect-square",
  "4:3": "aspect-4/3",
  "3:2": "aspect-3/2",
  "16:9": "aspect-video",
  "21:9": "aspect-21/9",
  "3:4": "aspect-3/4",
  "2:3": "aspect-2/3",
} as const;

export const RavioliMedia = ({
  aspectRatio,
  className,
  imageClassName,
  media,
  priority,
  sizes,
}: IRavioliMediaProps) => {
  const Image = getComponent("Image");
  return (
    <figure className={cn("relative min-w-0", className)}>
      <div
        className={cn(
          "relative h-full w-full overflow-hidden border border-line bg-surface-200",
          aspectRatio && ratios[aspectRatio],
        )}
      >
        <Image
          alt={media.alternateText}
          className="h-full w-full"
          height={media.height || undefined}
          imageClassName={cn(
            "h-full w-full",
            aspectRatio ? "object-cover" : "object-contain",
            imageClassName,
          )}
          priority={priority}
          sizes={sizes || media.sizes || undefined}
          src={media.defaultSrc}
          srcSet={media.srcSet || undefined}
          width={media.width || undefined}
        />
      </div>
      {media.caption ? (
        <figcaption className="mt-3 max-w-[65ch] font-ravioli-body text-[0.8125rem] leading-[1.125rem] text-ink-muted">
          {media.caption}
        </figcaption>
      ) : null}
    </figure>
  );
};

RavioliMedia.displayName = "Content::RavioliMedia";
